import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'

const ContentCarFinance = () => {
    return (
        <>
            <Heading variant="100" as="h1">
                Guide to car loans
            </Heading>
            <Heading variant="60" as="h2">
                What is a car finance loan?
            </Heading>
            <Text>
                The clue is in the name – a car finance loan can help you secure
                the money for a new car. Buying a new car often involves
                haggling for a great deal, so it makes sense that you should
                find the best loan option as well. Of course there are many
                different ways to find the money in order to buy a car, with car
                finance loans being just one of them. Let’s look into the
                various options available to you.
            </Text>
            <Heading variant="60" as="h2">
                What types of car finance loans are available?{' '}
            </Heading>
            <Text>
                With a hire purchase plan you are required to pay a deposit
                upfront and commit to a set number of monthly payments.
            </Text>
            <Text>
                While this type of loan means you get your car from the start of
                the agreement, it can be repossessed if you fall behind on your
                payments. You are essentially hiring the car until all the
                payments are made, at which point you are given an ‘option to
                purchase’, which is a final payment to make the car officially
                yours. Another snag with this option is that you will also be
                unable to sell the car while you are still making the payments,
                as technically you don’t fully own it yet.
            </Text>
            <Text>
                <a
                    href="https://www.totallymoney.com/loans/personal-loan/"
                    target="_blank"
                >
                    Personal loans
                </a>{' '}
                can also be used to help finance a car, and many people find one
                of these before they secure the finances needed before
                purchasing the car. Obviously this option means that you will
                own the car outright and will be able to sell it whenever you
                please, however you will still be making regular payments on the
                loan you took out.
            </Text>
            <Text>
                Make sure you compare the car loans available to you to make
                sure you find the option that works well for you.
            </Text>
            <Heading variant="60" as="h2">
                Pros and cons of car loans
            </Heading>
            <Text>
                A car finance loan is a great way to spread the cost of a large
                purchase, and will enable you to get the keys to a new car
                almost immediately, rather than having to save up
            </Text>
            <Text>
                Some loans will also be flexible in term of repayment period –
                some will require you to pay all the money back in a year, other
                could give you up to five years to make the last payment.
                However, be aware that the longer it takes you to pay the loan
                back the more interest you will be paying.
            </Text>
            <Text>
                However the interest on the money borrowed can mean that you end
                up paying more than the car’s original price tag, meaning that
                using savings to buy a new car can sometimes be a better option.
            </Text>
            <Text>
                It’s important to remember that with a car finance loan, as we
                have said above, you don’t technically own the car until the
                last payment is made. You should also be aware that having poor
                credit can impact the amount of money you are able to borrow.
            </Text>
            <Heading variant="60" as="h2">
                Alternatives to a car finance loan{' '}
            </Heading>
            <Text>
                While car finance loans are attractive because they directly
                relate to vehicles, they are not the only option when it comes
                to borrowing money for a new car.{' '}
            </Text>
            <Text>
                If you’re buying a relatively cheap car then a credit card might
                be a viable option. Many{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/purchase/"
                    target="_blank"
                >
                    purchase cards
                </a>{' '}
                offer a 0% introductory period which can help you with
                budgeted-for purchases. However you should only choose this
                option if you are confident that you can pay the money back
                before the 0% period ends.
            </Text>
            <Text>
                If you are buying the car with cash (which is likely to happen
                if it is a private sale) a{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/money-transfer-credit-cards/"
                    target="_blank"
                >
                    money transfer card
                </a>{' '}
                is also a good option to consider. Money transfer cards can be
                particularly useful when buying something like a car as they
                allow you to transfer cash from the money transfer card to your
                current account. Money transfer cards often have a 0%
                introductory interest rate, essentially acting as a small loan
                which you can use to raise the cash for a car. However, you must
                make sure you can pay back the money on the card before the
                introductory period ends, as the interest will often jump to a
                much higher rate after this period.
            </Text>
            <Heading variant="60" as="h2">
                Things to remember when looking for cheap car loans
            </Heading>
            <Text>
                Whenever you’re making a large purchase, the first thing that
                should always pop into your head is the{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/section-75-consumer-credit-act/"
                    target="_blank"
                >
                    Section 75 consumer protection benefit
                </a>
                . What is Section 75? This consumer legislation gives you
                protection on any purchases between £100 and £30,000 should
                anything go wrong. All you have to do is contact your credit
                card company and they will look into whether or not you can
                claim the money back. We strongly advise using a credit card to
                at least buy part of the car (if you are not paying in cash) so
                you can be protected should anything with the sale or the car
                itself goes wrong.
            </Text>
            <Text>
                While a car might be essential to your life, we would recommend
                making sure you don’t use all of your savings when putting down
                a deposit – make sure you have some funds left for an emergency.
            </Text>
            <Text>
                A car is a large purchase and an important one, so you want to
                make sure you don’t spend years paying it off at a huge interest
                rate. Use our price comparison tool to find the best option
                available to you before committing to any loan plan. If you have
                poor credit history you can also look for bad credit car loans.
            </Text>
            <Text>
                Also, remember that the size of the loan you are likely to be
                offered will be affected by your credit rating. If you have bad
                credit history then lenders might not offer you a large loan,
                meaning you might have to find some of the money to buy your car
                elsewhere.
            </Text>
            <Heading variant="60" as="h2">
                Is a car finance loan right for me?
            </Heading>
            <Text>
                You need to consider how much money you want to spend on a car,
                how urgently you need it and how much of your savings you are
                willing to part with in order to fund it.
            </Text>
            <Text>
                As we have discussed, car finance loans are not the only way to
                secure money for a car, so you need to assess all your options
                and make sure you chose the one which is best for you and your
                financial situation.
            </Text>
            <Text>
                Perhaps a credit card might be a better option to help finance
                your car? Or, if you need to buy a car quickly, a personal loan?
            </Text>
            <Text>
                You must also be aware that when taking out any loan you will be
                paying interest on what you owe, meaning that the final price
                you pay for the car will be more than its listed sale price.
            </Text>
        </>
    )
}

export default ContentCarFinance
